import { Component, OnInit, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-user-page-header',
    templateUrl: './user-page-header.component.html',
    styleUrls: ['./user-page-header.component.scss']
})
export class UserPageHeaderComponent implements OnInit {
    @Input() heading: string;
    @Input() icon: string;
    constructor() {}

    ngOnInit() {}
}
